import { Autocomplete, TextField } from 'components/mui';
import ChecklistTypes from '../../constants/checklistTypes';

const ChecklistTypeSelector = ({ checklistType, setChecklistType }) => {
	const onChange = (e, value) => {
		setChecklistType(value);
	};

	return (
		<Autocomplete
			value={checklistType}
			style={{ width: '300px' }}
			options={Object.values(ChecklistTypes)}
			onChange={onChange}
			disableClearable={true}
			renderInput={(params) => (
				<TextField
					{...params}
					variant="outlined"
					label="Checklist Type"
					InputLabelProps={{ shrink: true }}
				/>
			)}
		/>
	);
};

export default ChecklistTypeSelector;
